﻿/**
 * Load jQuery. This file works around an issue with loading jQuery and jQuery plugins via esbuild.
 */

import $ from 'jquery';
window.$ = window.jQuery = $;
